module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-layout o-layout--spacing-large"
  }, [_c('section', {
    staticClass: "o-layout__item u-align-center"
  }, [_c('h1', {
    staticClass: "c-type-alpha u-bold u-type-pink"
  }, [_vm._v("Page not found")]), _vm._v(" "), _c('p', [_vm._v("Sorry, this page doesn't exist.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-118ed6e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pageNotFound.vue
// module id = 137
// module chunks = 1